import {bidderPerformanceSellerService} from 'services/seller';
import {SELLER_META_SHOW_KEYS_METRICS} from 'utils/seller/sellerMetaUtils';
import {getPositivePerformanceKeysMetrics} from 'utils/seller/sellerResultUtils';

export const FETCH_ALL_PLACEMENTS_BIDDER_PERFORMANCE = 'FETCH_ALL_PLACEMENTS_BIDDER_PERFORMANCE';
export const SET_ALL_PLACEMENTS_BIDDER_PERFORMANCE = 'SET_ALL_PLACEMENTS_BIDDER_PERFORMANCE';
export const FETCH_SUMMARY_BIDDER_PERFORMANCE = 'FETCH_SUMMARY_BIDDER_PERFORMANCE';
export const SET_SUMMARY_BIDDER_PERFORMANCE = 'SET_SUMMARY_BIDDER_PERFORMANCE';

const bidderPerformanceSellerStore = {
  namespaced: true,
  state: {
    allPlacementsBidderPerformance: null,
    summaryBidderPerformance: null
  },
  getters: {
    allPlacementsBidderPerformance (state) {
      return state.allPlacementsBidderPerformance;
    },
    allowShowKeysMetrics (state, getters, rootState, rootGetters) {
      return rootGetters['sellerUser/userMeta'][SELLER_META_SHOW_KEYS_METRICS] || [];
    },
    summaryBidderPerformance (state) {
      return state.summaryBidderPerformance;
    }
  },
  mutations: {
    [SET_ALL_PLACEMENTS_BIDDER_PERFORMANCE] (state, allPlacementsBidderPerformance) {
      state.allPlacementsBidderPerformance = allPlacementsBidderPerformance;
    },
    [SET_SUMMARY_BIDDER_PERFORMANCE] (state, summaryBidderPerformance) {
      state.summaryBidderPerformance = summaryBidderPerformance;
    }
  },
  actions: {
    async [FETCH_ALL_PLACEMENTS_BIDDER_PERFORMANCE] (context, params) {
      const allPlacementsBidderPerformance =
        await bidderPerformanceSellerService.getAllPlacementsBidderPerformance(params);
      context.commit(SET_ALL_PLACEMENTS_BIDDER_PERFORMANCE, allPlacementsBidderPerformance.campaigns);
    },
    async [FETCH_SUMMARY_BIDDER_PERFORMANCE] (context) {
      if (context.state.summaryBidderPerformance) {
        return;
      }

      const summaryBidderPerformance = await bidderPerformanceSellerService.getSummaryBidderPerformance();

      const performanceKeysMetrics = getPositivePerformanceKeysMetrics(summaryBidderPerformance);
      const mergedKeys = Array.from(new Set([
        ...context.getters.allowShowKeysMetrics,
        ...performanceKeysMetrics
      ]));

      if (mergedKeys.length >= 2) {
        await context.dispatch(
          'sellerUser/SET_META_PROJECT',
          {[SELLER_META_SHOW_KEYS_METRICS]: mergedKeys},
          {root: true}
        );
      }

      context.commit(SET_SUMMARY_BIDDER_PERFORMANCE, summaryBidderPerformance);
    }
  }
};

export default bidderPerformanceSellerStore;
